import {useContext, useEffect} from "react";
import {UNSAFE_NavigationContext} from "react-router-dom";
import {confirmDialog} from "primereact/confirmdialog";

// Unsaved-changes guard (spec §41). HashRouter is not a data router, so `useBlocker` is unavailable; while the page
// is dirty the router's navigator asks first, and closing/reloading the tab shows the browser's own warning.
export default function useUnsavedGuard(dirty, message = "تغییرات ذخیره‌نشده دارید. بدون ذخیره خارج می‌شوید؟") {
    const {navigator} = useContext(UNSAFE_NavigationContext);

    useEffect(() => {
        if (!dirty) return undefined;
        const {push, replace} = navigator;
        const guard = (original) => (...args) => {
            confirmDialog({
                message,
                header: "خروج از تنظیمات اعلان‌ها",
                icon: "pi pi-exclamation-triangle",
                acceptLabel: "خروج بدون ذخیره",
                rejectLabel: "ماندن",
                className: "rtl",
                accept: () => original.apply(navigator, args),
            });
        };
        navigator.push = guard(push);
        navigator.replace = guard(replace);
        const beforeUnload = (event) => {
            event.preventDefault();
            event.returnValue = "";
        };
        window.addEventListener("beforeunload", beforeUnload);
        return () => {
            navigator.push = push;
            navigator.replace = replace;
            window.removeEventListener("beforeunload", beforeUnload);
        };
    }, [dirty, message, navigator]);
}
